export default {
  // FAILED_CONNECTION_NOTIFICATION: '',
  // Do not localize {Retry}; it is a placeholder for "Retry". English translation should be, "Send failed. Retry."
  SEND_FAILED_KEY: `αποτυχία, {Retry}.`,
  // SLOW_CONNECTION_NOTIFICATION: '',
  Chat: 'Συνομιλία',
  // 'Download file': '',
  // 'Microphone off': '',
  // 'Microphone on': '',
  'Listening…': 'Ακούγοντας…',
  Retry: 'δοκιμή',
  Send: 'Αποστολή',
  Sending: 'αποστολή',
  // 'Speak': '',
  // 'Starting…': '',
  Tax: 'ΦΠΑ',
  Total: 'Σύνολο',
  'Type your message': 'Πληκτρολόγηση μηνύματος',
  // 'Upload file': '',
  VAT: 'VAT'
  // 'X minutes ago':
};
